/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Image",
  size: 20
}

const SvgImage = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle cx={16.1} cy={6.1} r={1.1} />
    <path fill="none" d="M.5 2.5h19v15H.5z" />
    <path fill="none" strokeWidth={1.01} d="M4 13l4-4 5 5" />
    <path fill="none" strokeWidth={1.01} d="M11 12l1.5-1.5L16 14" />
  </Svg>
)

SvgImage.defaultProps = defaultProps
export default SvgImage
